import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { fetchEntryBySlug } from '../lib/cms';
import ContactForm from '../components/ContactForm';

export default function FaaEtTilbud() {
  const [pageData, setPageData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function loadData() {
      try {
        const page = await fetchEntryBySlug('da', 'faa-et-tilbud');
        setPageData(page);
      } catch (err) {
        console.error('Error loading faa-et-tilbud data:', err);
      } finally {
        setLoading(false);
      }
    }
    loadData();
  }, []);

  const metaTitle = pageData?.meta_title?.da || pageData?.meta_title || "Få et uforpligtende tilbud | Tømrer & Murer | SKT Byg";
  const metaDesc = pageData?.meta_description?.da || pageData?.meta_description || "Få et hurtigt og uforpligtende tilbud på dit næste bygge- eller renoveringsprojekt hos SKT Byg. Udfyld kontaktformularen med dine ønsker i dag.";

  const pageTitle = pageData?.page_title?.da || pageData?.page_title || "Få et tilbud";
  const pageSubtitle = pageData?.page_subtitle?.da || pageData?.page_subtitle || "Planlægger du et større eller mindre tømrerprojekt? Vi giver gerne et uforpligtende tilbud på din tømreropgave. Beskriv arbejdsopgaven i formularen, så vender vi tilbage hurtigst muligt.";
  const sectionTitle = pageData?.contact_title?.da || pageData?.contact_title || "Uforpligtende tilbud";
  const sectionText = pageData?.contact_text?.da || pageData?.contact_text || "Udfyld formularen til højre, så kontakter vi dig med et skræddersyet tilbud på din opgave.";
  const sectionImg = (pageData?.section_images && pageData.section_images[0]) || "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/47bb99a3-111d-47bf-9e96-8ebfe359b0ab/imgi-30-slider-8.jpg";

  return (
    <div className="min-h-screen bg-brand-light py-16">
      <Helmet>
        <title>{metaTitle}</title>
        <meta name="description" content={metaDesc} />
        <meta property="og:title" content={metaTitle} />
        <meta property="og:description" content={metaDesc} />
        <meta property="og:image" content="https://assets.auxodev.dk/assets/47bb99a3-111d-47bf-9e96-8ebfe359b0ab/faa-et-tilbud.jpg" />
      </Helmet>

      <div className="mx-auto max-w-7xl px-6">
        {/* Sidetitel */}
        <div className="text-left max-w-3xl mb-16">
          <h1 className="text-4xl md:text-5xl font-extrabold text-brand-dark mb-4">
            {pageTitle}
          </h1>
          <p className="text-lg text-brand-dark/70 leading-relaxed">
            {pageSubtitle}
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-start">
          {/* Tekst og Billede */}
          <div className="lg:col-span-5 space-y-8">
            <div>
              <h2 className="text-2xl font-extrabold text-brand-dark">
                {sectionTitle}
              </h2>
              <p className="text-brand-dark/70 text-sm leading-relaxed mt-2">
                {sectionText}
              </p>
            </div>

            <div className="rounded-2xl overflow-hidden shadow-sm border border-brand-sand h-64 md:h-80">
              <img
                src={sectionImg}
                alt="Få et godt tilbud"
                className="w-full h-full object-cover"
              />
            </div>
          </div>

          {/* Formular */}
          <div className="lg:col-span-7">
            <ContactForm subject="Henvendelse om Tilbud" />
          </div>
        </div>
      </div>
    </div>
  );
}
